import type { PresetTreeNode } from '@expostreamer/shared-types'

export function addPresetTreeNode(
  tree: PresetTreeNode | null,
  parentKey: string | null,
  presetName: string
): PresetTreeNode | null {
  const newNode: PresetTreeNode = { presetName, children: [] }

  if (parentKey === null) return newNode
  if (tree === null) return null

  if (tree.presetName === parentKey) return { ...tree, children: [...tree.children, newNode] }

  return {
    ...tree,
    children: tree.children.map(child => addPresetTreeNode(child, parentKey, presetName)!),
  }
}

export function removePresetTreeNode(tree: PresetTreeNode | null, key: string): PresetTreeNode | null {
  if (tree === null) return null
  if (tree.presetName === key) return null

  return {
    ...tree,
    children: tree.children
      .map(child => removePresetTreeNode(child, key))
      .filter((child): child is PresetTreeNode => child !== null),
  }
}

export function replacePresetTreeNode(
  tree: PresetTreeNode | null,
  key: string,
  newPresetName: string
): PresetTreeNode | null {
  if (tree === null) return null
  if (tree.presetName === key) return { ...tree, presetName: newPresetName }

  return {
    ...tree,
    children: tree.children.map(child => replacePresetTreeNode(child, key, newPresetName)!),
  }
}
